import type ProviderAccount from '~/types/ProviderAccount';

import { ActionKeys } from './constants';

export const fetchServiceLevelsByAccount = () =>
  <const>{
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT,
  };

export const fetchServiceLevelsByAccountSuccess = (providerAccounts: ProviderAccount[]) =>
  <const>{
    payload: {
      providerAccounts,
    },
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS,
  };

export const fetchServiceLevelsByAccountError = (errorMessage: string) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR,
  };

export type ProvidersActions =
  | ReturnType<typeof fetchServiceLevelsByAccount>
  | ReturnType<typeof fetchServiceLevelsByAccountError>
  | ReturnType<typeof fetchServiceLevelsByAccountSuccess>;
